import { setBreadcrumbs } from "../actions";

export default (from, to) => {
  return (dispatch, getState) => {
    if (from.step > to.step || from.subStep > to.subStep) {
      const currentBreadcrumbs = getState().itemBreadcrumbs;
      const newBreadcrumbs = {};
      const goToStep = to.step + ":" + to.subStep;
      for (const crumb in currentBreadcrumbs) {
        if (Object.prototype.hasOwnProperty.call(currentBreadcrumbs, crumb)) {
          /**
           * FROM: 0:5
           * TO: 0:4
           *
           * FROM: 1:0
           * TO: 0:6
           */
          if (crumb < goToStep) {
            newBreadcrumbs[crumb] = currentBreadcrumbs[crumb];
          }
        }
      }
      dispatch(setBreadcrumbs(newBreadcrumbs));
    }
  };
};
